/* eslint-disable */
import { Button, FormHelperText, Grid, InputAdornment, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_QUALITY_SELECTOR_CHANGE, UI_QUALITY_SELECTOR_DECREASE, UI_QUALITY_SELECTOR_INCREASE } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';
import PlaceOrderErrorMessage from './PlaceOrderErrorMessage.component';

/**
 * QuantitySelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const QuantitySelector = ({ actions, classes, defaultQuantity, onChange, isEdit, orderDateTime, disabled, initialValue, mandatoryFieldError }) => {
  const [quantity, setQuantity] = useState(defaultQuantity || 0);
  const [isValid, setIsValid] = useState(true);
  const [initialOrderDateTime] = useState(orderDateTime);

  const isTomorrowBefore10 = (orderDate) => {
    return orderDate.isBefore(
      moment()
        .add(1, `days`)
        .startOf(`day`)
        .add(10, `hours`),
    );
  };

  const shouldRestrict = (orderDate) => {
    const today = moment() // .add(5, `days`)
    const todayWeekday = moment(today).day()
    const startOfOrderDate = moment(orderDate).startOf(`day`)
    const tenAMOrderDate = moment(orderDate).startOf(`day`).add(10, `hours`)
    const daysDiff = moment(orderDate).startOf('day').diff(moment(today).startOf('day'), 'days')
    // today is Saturday, order date is coming Monday
    if (todayWeekday === 6 && daysDiff === 2) {
      return moment(orderDate).isBetween(startOfOrderDate, tenAMOrderDate)
    }
    // today is Friday, order date is coming Sunday
    if (todayWeekday === 5 && daysDiff === 2) {
      return moment(orderDate).isBetween(startOfOrderDate, tenAMOrderDate)
    }
    return isTomorrowBefore10(orderDate)
  }

  /**
   * Increase quantity
   * @param {Object} dateTime moment object
   * @returns {void} void
   */
  const increase = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `qualitySelectorIncrease`,
        },
      },
      type: UI_QUALITY_SELECTOR_INCREASE,
    });

    let maxQuantity = 2000;
    let minQuantity = 0.4;
    if (isEdit && shouldRestrict(moment(orderDateTime))) {
      maxQuantity = defaultQuantity + 7;
      minQuantity = defaultQuantity - 7;
    }

    let updatedQuantity = 0;
    if (!quantity) {
      updatedQuantity = minQuantity;
    } else if (((quantity + 0.2) * 1).toFixed(1) * 1 > maxQuantity) {
      updatedQuantity = quantity + 0.2;
      updatedQuantity = (updatedQuantity * 1).toFixed(1) * 1;
      setQuantity(updatedQuantity);
      onChange({ quantity: updatedQuantity, isValid: false });
      setIsValid(false);
      return;
    } else {
      updatedQuantity = ((quantity + 0.2) * 1).toFixed(1) * 1 < minQuantity ? minQuantity : ((quantity + 0.2) * 1).toFixed(1) * 1;
      if ((updatedQuantity * 10) % 2) {
        updatedQuantity -= 0.1;
        updatedQuantity = (updatedQuantity * 1).toFixed(1) * 1;
      }
    }
    setQuantity(updatedQuantity);
    onChange({ quantity: updatedQuantity, isValid: true });
    setIsValid(true);
    return;
  };

  /**
   * Decrease quantity
   * @returns {void} void
   */
  const decrease = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `qualitySelectorDecrease`,
        },
      },
      type: UI_QUALITY_SELECTOR_DECREASE,
    });

    let updatedQuantity = 0;
    if (!quantity) {
      return;
    }

    let maxQuantity = 2000;
    let minQuantity = 0.4;
    if (isEdit && shouldRestrict(moment(orderDateTime))) {
      maxQuantity = defaultQuantity + 7;
      minQuantity = defaultQuantity - 7;
    }
    updatedQuantity = (quantity - 0.2).toFixed(1) * 1;

    if (updatedQuantity < minQuantity || updatedQuantity < 0.4) {
      setQuantity(0);
      onChange({ quantity: 0, isValid: false });
      setIsValid(false);
    } else if (updatedQuantity > maxQuantity) {
      setQuantity(updatedQuantity);
      onChange({ quantity: updatedQuantity, isValid: false });
      setIsValid(false);
    } else if (((updatedQuantity * 1).toFixed(1) * 10) % 2) {
      updatedQuantity += 0.1;
      setQuantity(updatedQuantity.toFixed(1) * 1);
      onChange({ quantity: updatedQuantity.toFixed(1) * 1, isValid: true });
      setIsValid(true);
    } else {
      setQuantity(updatedQuantity);
      onChange({ quantity: updatedQuantity, isValid: true });
      setIsValid(true);
    }
    return;
  };

  /**
   * Changes quantity
   * @param {string} enteredQuantity moment object
   * @returns {void} void
   */
  const onQuantityChange = (enteredQuantity) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `qualitySelectorDecrease`,
        },
      },
      type: UI_QUALITY_SELECTOR_CHANGE,
    });

    let updatedQuantity = 0;
    const cleanedUpQuantity = enteredQuantity.replace(/[^0-9\.]/g, ``).replace(/\.{2,}/g, `.`);

    let maxQuantity = 2000;
    let minQuantity = 0.4;
    if (isEdit && shouldRestrict(moment(orderDateTime))) {
      maxQuantity = defaultQuantity + 7;
      minQuantity = defaultQuantity - 7;
    }

    if (cleanedUpQuantity * 1 < minQuantity) {
      setQuantity(cleanedUpQuantity * 1);
      onChange({ quantity: cleanedUpQuantity * 1, isValid: false });
      setIsValid(false);
    } else if (cleanedUpQuantity * 1 > maxQuantity) {
      setQuantity(cleanedUpQuantity * 1);
      onChange({ quantity: cleanedUpQuantity * 1, isValid: false });
      setIsValid(false);
    } else if (!(((cleanedUpQuantity * 1).toFixed(1) * 10) % 2)) {
      updatedQuantity = (cleanedUpQuantity * 1).toFixed(1) * 1;
      setQuantity(updatedQuantity);
      onChange({ quantity: updatedQuantity, isValid: true });
      setIsValid(true);
    } else {
      updatedQuantity = (cleanedUpQuantity * 1).toFixed(1) * 1;
      setQuantity(updatedQuantity);
      onChange({ quantity: updatedQuantity, isValid: false });
      setIsValid(false);
    }
    return;
  };

  useEffect(() => {
    if (initialOrderDateTime !== orderDateTime) {
      onQuantityChange(`${quantity}`);
    }
  }, [orderDateTime]);

  useEffect(() => {
    if (isEdit && initialValue) {
      setQuantity(initialValue)
    }
  }, [])

  let fieldClass = null;
  if (isEdit && !disabled) {
    fieldClass = defaultQuantity === quantity ? classes.editableField : classes.touchedField;
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="center" className={classes.flexWrapNowrap}>
          <Grid item className={classes.flexGrow1}>
            <TextField
              error={mandatoryFieldError}
              fullWidth
              disabled={disabled}
              id="quantity"
              value={quantity || ``}
              label={
                <span>
                  Quantity (m<sup>3</sup>)
                </span>
              }
              className={classes.quantityField}
              placeholder="0.0"
              onChange={(e) => {
                setQuantity(e.target.value);
                onChange({ quantity: e.target.value, isValid: true });
              }}
              onBlur={(e) => onQuantityChange(e.target.value)}
              InputProps={{
                className: fieldClass,
                startAdornment: (
                  <InputAdornment position="start">
                    <UnarchiveIcon className={classes.opacity05} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="body1">
                      m<sup>3</sup>
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />
            {isEdit && !disabled ? (
              <FormHelperText error={mandatoryFieldError}>
                Modify the required quantity to the nearest 0.2m<sup>3</sup>
              </FormHelperText>
            ) : (
              <FormHelperText error={mandatoryFieldError}>
                Enter the required quantity to the nearest 0.2 m<sup>3</sup>
              </FormHelperText>
            )}
          </Grid>
          {!disabled && (
            <Grid item>
              <Button variant="outlined" onClick={decrease}>
                <RemoveIcon />
              </Button>
            </Grid>
          )}
          {!disabled && (
            <Grid item>
              <Button variant="outlined" onClick={increase}>
                <AddIcon />
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
      {!isValid && (
        <Grid item xs={12}>
          <PlaceOrderErrorMessage
            message={
              isEdit ? (
                <Typography variant="body2" className={classes.errorText}>
                  You cannot modify to this quantity at this time. If your order is tomorrow before 10am, you may only modify the quantity by +/- 7m<sup>3</sup>
                  . Otherwise the allowable quantity is min 0.4m<sup>3</sup> and max 2000m<sup>3</sup>. For other modifications, please{` `}
                  <a
                    className={classes.errorText}
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                  >
                    Call Boral
                  </a>
                  .
                </Typography>
              ) : (
                <Typography variant="body2" className={classes.errorText}>
                  This quantity of the selected product cannot be ordered online. Please{` `}
                  <a
                    className={classes.errorText}
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.boral.com.au/locations?product_category%5B86%5D=86"
                  >
                    Call Boral
                  </a>
                  {` `}
                  to place your order
                </Typography>
              )
            }
          />
        </Grid>
      )}
    </Grid>
  );
};

// /* eslint-disable react/forbid-prop-types */
// /* eslint-disable react/require-default-props */
// QuantitySelector.propTypes = {
//   actions: PropTypes.object.isRequired,
//   classes: PropTypes.object.isRequired,
//   orderDateTime: PropTypes.object,
//   onChange: PropTypes.func.isRequired,
//   defaultQuantity: PropTypes.number,
//   isEdit: PropTypes.bool,
//   disabled: PropTypes.bool,
// };

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(QuantitySelector);
